import { useEffect, useState } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core-react/i18n';
import { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';

export const ExportNotifications: React.FC<Props> = ({ data }) => {
	const [showPageMessage, setShowPageMessage] = useState(false);
	const { typedTranslate } = useI18n();

	useEffect(() => {
		if (!data.loading && (data.errorMessage || data.successMessage)) {
			// eslint-disable-next-line react-hooks/set-state-in-effect
			setShowPageMessage(true);
			const timeout = setTimeout(() => {
				setShowPageMessage(false);
			}, 5000);
			return () => clearTimeout(timeout);
		}
		return undefined;
	}, [data.loading, data.errorMessage, data.successMessage, data]);

	if (data.loading) return null;

	if (showPageMessage && data.errorMessage) {
		return (
			<PageMessage
				mt={24}
				message={typedTranslate(data.errorMessage)}
				severity="critical"
				containerVariant="small"
				id="starter-dashboard-error-message"
				data-qa="starter-dashboard-export-button-error-message"
				sx={{
					position: 'absolute',
					left: 16,
					right: 16,
					bottom: 10,
					borderRadius: '0.5rem',
					zIndex: 9999,
					display: ['flex', 'flex'],
					justifyContent: 'center',
				}}
			/>
		);
	}
	if (showPageMessage && data.successMessage) {
		return (
			<PageMessage
				mt={24}
				message={typedTranslate(data.successMessage)}
				severity="success"
				containerVariant="small"
				id="starter-dashboard-error-message"
				data-qa="starter-dashboard-export-button-error-message"
				sx={{
					position: 'absolute',
					left: 16,
					right: 16,
					bottom: 10,
					borderRadius: '0.5rem',
					zIndex: 9999,
					display: ['flex', 'flex'],
					justifyContent: 'center',
				}}
			/>
		);
	}

	return null;
};

type Props = Readonly<{
	data: {
		loading: boolean;
		errorMessage: TranslationKey | null;
		successMessage: TranslationKey | null;
	};
}>;
